import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\r\n<g clip-path=\"url(#close_clip0_1248_5500)\">\r\n<path d=\"M17.9999 6.00006L6 18\" stroke=\"white\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n<path d=\"M6.00008 6.00006L18 18\" stroke=\"white\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</g>\r\n<defs>\r\n<clipPath id=\"close_clip0_1248_5500\">\r\n<rect width=\"24\" height=\"24\" fill=\"white\" />\r\n</clipPath>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol